module.exports = __webpack_public_path__ + "static/media/8174Fun88LogoBlue.fa15afa6.png";